import { evidenceTypeLog } from "security-app/components/Investigations/Details/TimelineSegment/Constants";
const isLogEvidenceType = (evidenceType) => evidenceType === evidenceTypeLog;
export const removeIlluminateEventDefinitionPrefix = (eventDefinitionTitle) => eventDefinitionTitle == null ? void 0 : eventDefinitionTitle.replace(/^Illuminate:Events:\d+[:;]/, "");
export const isLogEvidence = (evidence) => isLogEvidenceType(evidence.type);
export const evidenceTypeLabel = (evidenceType, lowercase = false) => {
  const label = isLogEvidenceType(evidenceType) ? "Message" : "Event";
  if (lowercase) {
    return label.toLocaleLowerCase();
  }
  return label;
};
